import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// components
//
import Main from './Main';
import Header from './header';
import NavVertical from './nav/NavVertical';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 'calc(100vh - 64px)' },
          width: '100%',
        }}
      >
        <NavVertical openNav={open} onCloseNav={handleClose} />

        <Main>
          <Outlet />
        </Main>
      </Box>
    </>
  );
}
